import { UIText3 } from '@cian/ui-kit/typography';
import * as classNames from 'classnames';
import * as React from 'react';

import * as styles from './ImageShield.css';
import { IImageShieldProps } from './types';

export const ImageShield: React.FC<IImageShieldProps> = props => {
  const { title, bgc, color, className } = props;

  return (
    <div className={classNames(styles['container'], styles[bgc], className)}>
      <UIText3 color={color || 'white_100'}>{title}</UIText3>
    </div>
  );
};

ImageShield.displayName = 'ImageShield';
